import httpService from "./httpService";

/**
 * Fetches a file (blob) from a full URL using the app's httpService so the
 * Authorization header is included.
 *
 * @param {string} url Full URL to fetch.
 * @returns {Promise<{ blob: Blob, headers: Headers }>} Blob and response headers
 */
export const getBlobFromUrl = async (url) => {
  try {
    const response = await httpService.get(url, { responseType: "blob" });
    // axios returns headers on response.headers as a plain object
    return { blob: response.data, headers: response.headers };
  } catch (err) {
    console.error("Failed to fetch file blob", err);
    throw err;
  }
};

/**
 * Convenience: fetch file by known fileName route used by backend
 * (e.g., /payment-mgmt/admin/file?fileName=...)
 */
export const getBlobByFileName = async (fileName) => {
  const encoded = encodeURIComponent(fileName || "");
  const url = `/payment-mgmt/admin/file?fileName=${encoded}`;
  return await getBlobFromUrl(url);
};
